module.exports = __webpack_public_path__ + "pc/img/main_work_img1.ddd63e7a.jpg";